export const VIBRANT_PALETTE = [
    '#667eea',
    '#764ba2',
    '#f093fb',
    '#f5576c',
    '#4facfe',
    '#00b4d8',
    '#43e97b',
    '#38b000',
    '#fa709a',
    '#f6c23e',
    '#ff6b6b',
    '#feca57',
    '#48dbfb',
    '#e83e8c',
    '#54a0ff',
    '#5f27cd',
];

export const getSeriesColors = (series = []) =>
    series.map((item, index) => item.color || VIBRANT_PALETTE[index % VIBRANT_PALETTE.length]);

export const getAccentColor = (index = 0, fallback) =>
    fallback || VIBRANT_PALETTE[index % VIBRANT_PALETTE.length];
